var map = {
	"./banhanguytin/4.png": "7d9d",
	"./cacung/4.png": "719c",
	"./chuyencan/4.png": "e79b",
	"./daigiadataha/4.png": "ebb0",
	"./duhanhgia/4.png": "bff8",
	"./thanhsanma/4.png": "e97e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5026";